const React = require('react');
const BaseComponent = require('../../shared/base');
const ChangeCurrencyControl = require('../../../public/js/bepensa/change-currency');
let changeCurrencyHandler = null;

class ChangeCurrency extends BaseComponent {
    constructor(props){
        super(props);
        this.subCurrencyCallbackHandler = this.subCurrencyCallbackHandler.bind(this);
    }
    
    componentDidMount(){
        changeCurrencyHandler = new ChangeCurrencyControl(this.subCurrencyCallbackHandler);
        if(this.props.changeCurrencyHandler != null){
            this.props.changeCurrencyHandler.currencyObject = changeCurrencyHandler;
        }

        if(this.props.isVisible){
            changeCurrencyHandler.subShow();
        }else{
            changeCurrencyHandler.subHide();
        }
    }

    componentDidUpdate(){
        if(this.props.isVisible && changeCurrencyHandler != null){
            changeCurrencyHandler.subShow();
        }else{
            changeCurrencyHandler.subHide();
        }
    }

    subCurrencyCallbackHandler(
		strCurrencyChangedBy_I
	)
	{
		//console.log("currency changed by: " + strCurrencyChangedBy_I);
        this.props.currencyCallbackHandler(strCurrencyChangedBy_I);
	}

    render(){
        return (
            <div className="idc-right" id="flag-container-idc">
                <div className="flag-container">
                    <img alt="" id="flag-image-mxn" src="/assets/images/bepensa/flag-mexico.svg"></img>
                    <img alt="" id="flag-image-usa" src="/assets/images/bepensa/flag-usa.svg" style={{ display : 'none'}}></img>
                    <select id="currency-selector">
                        <option>MXN</option>
                        <option>USD</option>
                    </select>
                </div>
            </div>
        );
    }
}
module.exports = ChangeCurrency;